<template>
    <div class="register" v-if="userStatus === 'registered' || userStatus === 'registered_and_waiting'">
        <div class="register-wrapper">
            <simple-svg :filepath="'/storage/img/icon/icon-confirm.svg'" />

            <div class="register-wrapper--content">
                <h3>{{ 'title'|t }}</h3>
                <p>{{ 'text'|t }}</p>
                <router-link to="/dashboard" class="btn-link btn-link--small">{{ 'cta'|t }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            status: null,
            userStatus: null
        }
    },
    mounted() {
        this.status = this.event.status;
        this.userStatus = this.event.userStatus;
    }
}
</script>

<i18n>
    {
      "en": {
        "title" : "Already booked",
        "text" : "You’ve already booked tickets for this workshop. We can't wait to see you there!",
        "cta" : "Change my booking"
      },
      "fr": {
        "title" : "Déjà réservé",
        "text" : "Vous avez déjà réservé des tickets pour ce workshop. Nous avons hâte de vous y voir !",
        "cta" : "Modifier la réservation"
      }
    }
</i18n>